import { FC } from 'react'

import { formatCurrency } from 'utils'
import { Button, Typography, Icon, Heading } from 'components/ui'

import { IconTypes } from '~ui/Icon'
import classNames from 'classnames'
import styles from './Ticket.module.scss'

type Helper = {
  glowColor?: GThemeColorsNew
  icon?: IconTypes
  text: string
}

export type TicketProps = {
  price: number
  title: string
  quantity: number
  onClick: () => void
  color?: GThemeColorsNew
  prefix?: string
  helper?: Helper
  prevPrice?: number
}

const Ticket: FC<TicketProps> = ({ onClick, title, quantity, prefix, color, helper, ...props }) => {
  const price = formatCurrency(props.price, 0)
  const subtitle = `${quantity} tickets`

  return (
    <div className={styles.ticket} onClick={onClick} aria-hidden>
      <Button
        className={classNames({ [styles.sale]: props.prevPrice })}
        variant="primary"
        clr={color}
      >
        <span>{price}</span>
        {props.prevPrice && (
          <span className={styles.prevPrice}>{formatCurrency(props.prevPrice || 0, 0)}</span>
        )}
      </Button>
      <div className={styles.description}>
        {helper && (
          <Heading Tag="span" colorGlow={helper.glowColor} className={styles.helper}>
            {helper.icon && (
              <Icon name="lightning-v2" glowColor={helper.glowColor} className={styles.icon} />
            )}
            {helper.text}
          </Heading>
        )}

        <Typography.Text bold>{title}</Typography.Text>
        <Typography.Text color="g-gray-1">
          {prefix && (
            <>
              <Heading Tag="span" colorGlow={color}>
                {prefix}
              </Heading>
              {' • '}
            </>
          )}
          {subtitle}
        </Typography.Text>
      </div>
      <Icon name="right-arrow" width="1em" height="1em" fill="currentColor" />
    </div>
  )
}

export default Ticket
